import { root } from './encoders';

export const encoders = {
  ...root,
};
